(function () {
  var root = document.querySelector('[data-cp-root]');
  if (!root) return;

  var heroImg = root.querySelector('[data-cp-hero-img]');
  var thumbs = root.querySelectorAll('[data-cp-thumb]');
  var checkoutBtn = root.querySelector('[data-cp-checkout]');
  var errorEl = root.querySelector('[data-cp-error]');
  var progressLineEl = root.querySelector('[data-cp-progress-line]');
  var saveBadge = root.querySelector('[data-cp-save-badge]');
  var expandSaveSubs = root.querySelectorAll('.cp-pair-expand-sub');
  var totalCompare = root.querySelector('[data-cp-total-compare]');
  var totalPrice = root.querySelector('[data-cp-total-price]');
  var mmEl = root.querySelector('[data-cp-mm]');
  var ssEl = root.querySelector('[data-cp-ss]');

  var variants = [];
  var options = [];
  try {
    variants = JSON.parse(root.querySelector('[data-cp-variants]').textContent);
    options = JSON.parse(root.querySelector('[data-cp-options]').textContent);
  } catch (e) {}

  function normalizeOptionName(name) {
    return String(name || '')
      .toLowerCase()
      .trim()
      .replace(/ß/g, 'ss')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ñ/g, 'n');
  }

  function isColorOptionName(name) {
    var n = normalizeOptionName(name);
    if (!n) return false;
    if (n === 'color' || n === 'colour' || n === 'farbe' || n === 'couleur' || n === 'colore' || n === 'farbung' || n === 'faebung' || n === 'kleur') return true;
    if (n.indexOf('farbe') !== -1) return true;
    return false;
  }

  function isSizeOptionName(name) {
    var n = normalizeOptionName(name);
    if (!n) return false;
    if (n === 'size' || n === 'groesse' || n === 'grosse' || n === 'taille' || n === 'talla' || n === 'tamano' || n === 'maat') return true;
    return false;
  }

  var colorOptionIndex = -1;
  var sizeOptionIndex = -1;
  options.forEach(function (opt, i) {
    if (isColorOptionName(opt.name)) colorOptionIndex = i;
    else if (isSizeOptionName(opt.name)) sizeOptionIndex = i;
  });

  if (options.length === 2) {
    if (colorOptionIndex === -1 && sizeOptionIndex === -1) {
      colorOptionIndex = 0;
      sizeOptionIndex = 1;
    } else if (colorOptionIndex === -1 && sizeOptionIndex >= 0) {
      colorOptionIndex = sizeOptionIndex === 0 ? 1 : 0;
    } else if (sizeOptionIndex === -1 && colorOptionIndex >= 0) {
      sizeOptionIndex = colorOptionIndex === 0 ? 1 : 0;
    }
  }

  function optionLabelAt(idx) {
    return idx >= 0 && options[idx] ? options[idx].name : '';
  }

  var colorLabel = optionLabelAt(colorOptionIndex) || 'Farbe';
  var sizeLabel = optionLabelAt(sizeOptionIndex) || 'Größe';

  function applySelectLabels() {
    root.querySelectorAll('[data-cp-select-label="first"]').forEach(function (el) {
      el.textContent = colorLabel;
    });
    root.querySelectorAll('[data-cp-select-label="second"]').forEach(function (el) {
      el.textContent = sizeLabel;
    });
  }
  applySelectLabels();

  function initSizePlaceholders() {
    for (var p = 1; p <= 3; p++) {
      var sizeSel = root.querySelector('[data-cp-size="' + p + '"]');
      if (!sizeSel || !sizeSel.options[0]) continue;
      sizeSel.options[0].textContent = sizeLabel;
    }
  }
  initSizePlaceholders();

  var colorValues = colorOptionIndex >= 0 ? options[colorOptionIndex].values : [];

  var tierDiscounts = { 1: 0, 2: 0.10, 3: 0.20 };

  var params = new URLSearchParams(window.location.search);
  var currentPairs = Math.min(3, Math.max(1, parseInt(params.get('quantity') || '1', 10) || 1));

  // Timer
  var timerSec = parseInt(root.getAttribute('data-timer-seconds') || '600', 10);
  if (isNaN(timerSec) || timerSec < 1) timerSec = 600;
  var timerEndMs = Date.now() + timerSec * 1000;

  function pad2(n) { return String(n).padStart(2, '0'); }

  function tickTimer() {
    var diff = Math.max(0, timerEndMs - Date.now());
    var m = Math.floor(diff / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (mmEl) mmEl.textContent = pad2(m);
    if (ssEl) ssEl.textContent = pad2(s);
  }
  tickTimer();
  setInterval(tickTimer, 1000);

  // Show correct pair rows — all 3 are always visible, only expand up to currentPairs
  function showPairRows(count) {
    for (var p = 1; p <= 3; p++) {
      var row = root.querySelector('[data-cp-pair="' + p + '"]');
      if (!row) continue;
      row.classList.add('is-visible');
      if (p <= count) {
        row.classList.add('is-expanded');
      } else {
        row.classList.remove('is-expanded');
      }
    }
  }
  showPairRows(currentPairs);

  // Populate color dropdowns
  function populateColorDropdowns() {
    for (var p = 1; p <= 3; p++) {
      var sel = root.querySelector('[data-cp-color="' + p + '"]');
      if (!sel) continue;
      sel.innerHTML = '';
      var emptyC = document.createElement('option');
      emptyC.value = '';
      emptyC.textContent = colorLabel;
      sel.appendChild(emptyC);
      colorValues.forEach(function (val) {
        var name = typeof val === 'string' ? val : val.name || val;
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        sel.appendChild(opt);
      });
    }
  }
  populateColorDropdowns();

  function getOptionValue(variant, optIndex) {
    if (optIndex < 0) return '';
    return variant['option' + (optIndex + 1)] || '';
  }

  function getAvailableSizes(colorName) {
    var sizes = [];
    var seen = {};
    variants.forEach(function (v) {
      if (!v.available) return;
      var vColor = getOptionValue(v, colorOptionIndex);
      if (vColor !== colorName) return;
      var vSize = getOptionValue(v, sizeOptionIndex);
      if (vSize && !seen[vSize]) {
        seen[vSize] = true;
        sizes.push(vSize);
      }
    });
    return sizes;
  }

  function findVariant(colorName, sizeName) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      if (getOptionValue(v, colorOptionIndex) === colorName && getOptionValue(v, sizeOptionIndex) === sizeName) return v;
    }
    return null;
  }

  function getVariantImage(colorName) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (getOptionValue(v, colorOptionIndex) === colorName && v.featured_image) {
        return v.featured_image.src;
      }
    }
    return null;
  }

  function updatePairThumb(pairIndex, imgSrc) {
    var img = root.querySelector('[data-cp-pair-img="' + pairIndex + '"]');
    if (img && imgSrc) img.src = imgSrc;
  }

  function onColorChange(pairIndex) {
    var colorSel = root.querySelector('[data-cp-color="' + pairIndex + '"]');
    var sizeSel = root.querySelector('[data-cp-size="' + pairIndex + '"]');
    if (!colorSel || !sizeSel) return;

    var colorName = colorSel.value;
    sizeSel.innerHTML = '';
    var emptyS = document.createElement('option');
    emptyS.value = '';
    emptyS.textContent = sizeLabel;
    sizeSel.appendChild(emptyS);

    if (!colorName) {
      sizeSel.disabled = true;
      updatePairThumb(pairIndex, null);
      updateState();
      return;
    }

    sizeSel.disabled = false;
    var sizes = getAvailableSizes(colorName);
    sizes.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      sizeSel.appendChild(opt);
    });

    var imgSrc = getVariantImage(colorName);
    updatePairThumb(pairIndex, imgSrc);
    if (imgSrc && heroImg) {
      heroImg.src = imgSrc;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    }

    updateState();
  }

  function onSizeChange(pairIndex) {
    var row = root.querySelector('[data-cp-pair="' + pairIndex + '"]');
    var colorSel = root.querySelector('[data-cp-color="' + pairIndex + '"]');
    var sizeSel = root.querySelector('[data-cp-size="' + pairIndex + '"]');
    if (colorSel && colorSel.value && sizeSel && sizeSel.value) {
      row && row.classList.add('is-complete');
    } else {
      row && row.classList.remove('is-complete');
    }
    updateState();
  }

  function updateState() {
    var completedCount = 0;
    var allItems = [];

    for (var p = 1; p <= currentPairs; p++) {
      var colorSel = root.querySelector('[data-cp-color="' + p + '"]');
      var sizeSel = root.querySelector('[data-cp-size="' + p + '"]');
      var color = colorSel ? colorSel.value : '';
      var size = sizeSel ? sizeSel.value : '';
      if (color && size) {
        completedCount++;
        var v = findVariant(color, size);
        if (v) allItems.push(v);
      }
    }

    var stepsLeft = currentPairs - completedCount;
    if (progressLineEl) {
      if (stepsLeft === 0) {
        progressLineEl.innerHTML = 'Du bist <strong>bereit für besseres Gehen</strong>.';
      } else {
        var stepWord = stepsLeft === 1 ? 'Schritt' : 'Schritte';
        progressLineEl.innerHTML =
          'Noch ' + stepsLeft + ' ' + stepWord + ' bis zu <strong>besserem Gehen</strong>';
      }
    }

    updateTotals(allItems);
    if (errorEl) errorEl.classList.remove('is-visible');
  }

  function applyDefaultTotals() {
    var defP = parseInt(root.getAttribute('data-cp-default-price'), 10);
    var defC = parseInt(root.getAttribute('data-cp-default-compare'), 10);
    if (!defP || !defC) {
      if (totalPrice) totalPrice.textContent = '';
      if (totalCompare) totalCompare.textContent = '';
      if (saveBadge) saveBadge.textContent = '';
      updateExpandSaveTexts(defP || 0, defC || 0);
      return;
    }
    var disc = tierDiscounts[currentPairs] || 0;
    var total = Math.round(defP * (1 - disc)) * currentPairs;
    var compareTotal = defC * currentPairs;
    if (totalPrice) totalPrice.textContent = formatMoney(total);
    if (totalCompare) {
      totalCompare.textContent = compareTotal > total ? formatMoney(compareTotal) : '';
    }
    if (saveBadge) {
      if (compareTotal <= total) {
        saveBadge.textContent = '';
      } else {
        var pct = Math.round(((compareTotal - total) / compareTotal) * 100);
        if (pct < 0) pct = 0;
        saveBadge.textContent = pct + ' % RABATT';
      }
    }
    updateExpandSaveTexts(defP, defC);
  }

  function updateExpandSaveTexts(unitPrice, unitCompare) {
    for (var t = 2; t <= 3; t++) {
      var sub = root.querySelector('[data-cp-pair="' + t + '"] .cp-pair-expand-sub');
      if (!sub) continue;
      var msg = '';
      if (unitCompare > 0 && unitPrice > 0) {
        var disc = tierDiscounts[t] || 0;
        var discPrice = Math.round(unitPrice * (1 - disc));
        var tierTotal = discPrice * t;
        var tierCompare = unitCompare * t;
        if (tierCompare > tierTotal) {
          var p = Math.round(((tierCompare - tierTotal) / tierCompare) * 100);
          if (p > 0) msg = 'Spare ' + p + ' % gegenüber UVP bei ' + t + ' Paaren';
        }
      }
      sub.textContent = msg;
    }
  }

  function updateTotals(items) {
    if (items.length === 0) {
      applyDefaultTotals();
      return;
    }

    var disc = tierDiscounts[currentPairs] || 0;
    var total = 0;
    var compareTotal = 0;
    var unitPriceSum = 0;
    var unitCompareSum = 0;
    items.forEach(function (v) {
      var discPrice = Math.round(v.price * (1 - disc));
      total += discPrice;
      var cmp = v.compare_at_price;
      if (cmp == null || cmp === '') {
        cmp = v.price;
      }
      compareTotal += cmp;
      unitPriceSum += v.price;
      unitCompareSum += cmp;
    });

    var avgPrice = items.length > 0 ? Math.round(unitPriceSum / items.length) : 0;
    var avgCompare = items.length > 0 ? Math.round(unitCompareSum / items.length) : 0;

    if (totalPrice) totalPrice.textContent = formatMoney(total);
    if (totalCompare) {
      totalCompare.textContent = compareTotal > total ? formatMoney(compareTotal) : '';
    }
    if (saveBadge) {
      if (compareTotal <= total) {
        saveBadge.textContent = '';
      } else {
        var pct = Math.round(((compareTotal - total) / compareTotal) * 100);
        if (pct < 0) pct = 0;
        saveBadge.textContent = pct + ' % RABATT';
      }
    }
    updateExpandSaveTexts(avgPrice, avgCompare);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Thumbnail navigation
  var thumbsRail = root.querySelector('[data-cp-thumbs]');
  var currentThumbIndex = 0;

  function scrollThumbIntoView(btn) {
    if (!thumbsRail || !btn) return;
    var rRect = thumbsRail.getBoundingClientRect();
    var bRect = btn.getBoundingClientRect();
    var target = thumbsRail.scrollLeft + (bRect.left - rRect.left) - (thumbsRail.clientWidth - bRect.width) / 2;
    thumbsRail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  function selectThumb(index) {
    if (thumbs.length === 0) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentThumbIndex = index;
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumbs[index].classList.add('is-active');
    if (heroImg) heroImg.src = thumbs[index].getAttribute('data-img-src');
    scrollThumbIntoView(thumbs[index]);
  }
  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { selectThumb(i); });
  });

  var prevBtn = root.querySelector('[data-cp-prev]');
  var nextBtn = root.querySelector('[data-cp-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { selectThumb(currentThumbIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { selectThumb(currentThumbIndex + 1); });

  var thumbsPrev = root.querySelector('[data-cp-thumbs-prev]');
  var thumbsNext = root.querySelector('[data-cp-thumbs-next]');
  if (thumbsPrev && thumbsRail) {
    thumbsPrev.addEventListener('click', function () {
      thumbsRail.scrollBy({ left: -thumbsRail.clientWidth * 0.8, behavior: 'smooth' });
    });
  }
  if (thumbsNext && thumbsRail) {
    thumbsNext.addEventListener('click', function () {
      thumbsRail.scrollBy({ left: thumbsRail.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  // Expand buttons for pair 2/3 — also increases currentPairs
  root.querySelectorAll('[data-cp-expand]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.cp-pair-row');
      if (!row) return;
      var pairNum = parseInt(row.getAttribute('data-cp-pair'), 10);
      if (pairNum > currentPairs) currentPairs = pairNum;
      row.classList.add('is-expanded');
      updateState();
    });
  });

  // Color/size change handlers
  for (var p = 1; p <= 3; p++) {
    (function (idx) {
      var colorSel = root.querySelector('[data-cp-color="' + idx + '"]');
      var sizeSel = root.querySelector('[data-cp-size="' + idx + '"]');
      if (colorSel) colorSel.addEventListener('change', function () { onColorChange(idx); });
      if (sizeSel) sizeSel.addEventListener('change', function () { onSizeChange(idx); });
    })(p);
  }

  // Checkout: clear cart -> add items -> redirect
  checkoutBtn.addEventListener('click', function () {
    var items = [];
    for (var p = 1; p <= currentPairs; p++) {
      var colorSel = root.querySelector('[data-cp-color="' + p + '"]');
      var sizeSel = root.querySelector('[data-cp-size="' + p + '"]');
      var color = colorSel ? colorSel.value : '';
      var size = sizeSel ? sizeSel.value : '';
      if (!color || !size) {
        if (errorEl) {
          errorEl.textContent = 'Bitte Farbe und Größe für alle Paare wählen.';
          errorEl.classList.add('is-visible');
        }
        return;
      }
      var v = findVariant(color, size);
      if (!v) {
        if (errorEl) {
          errorEl.textContent = 'Variant not available for pair ' + p + '. Please choose another combination.';
          errorEl.classList.add('is-visible');
        }
        return;
      }
      items.push({ id: v.id, quantity: 1 });
    }

    if (items.length !== currentPairs) return;

    checkoutBtn.disabled = true;
    checkoutBtn.querySelector('span').textContent = 'Wird bearbeitet …';

    function getCheckoutDiscountCode() {
      var c2 = (root.getAttribute('data-cp-discount-code-2') || '').trim();
      var c3 = (root.getAttribute('data-cp-discount-code-3') || '').trim();
      if (currentPairs === 3) return c3;
      if (currentPairs === 2) return c2;
      return '';
    }

    function finalizeCheckout(code) {
      var attrKey = (root.getAttribute('data-cp-cart-attr-key') || '').trim();
      var attrVal = (root.getAttribute('data-cp-cart-attr-value') || '').trim();
      var payload = {};
      if (attrKey) {
        payload.attributes = {};
        payload.attributes[attrKey] = attrVal;
      }
      if (code) {
        payload.discount = code;
      }
      if (Object.keys(payload).length === 0) {
        window.location = '/checkout';
        return;
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (cart.status && code) {
            window.location = '/checkout?discount=' + encodeURIComponent(code);
            return;
          }
          window.location = '/checkout';
        })
        .catch(function () {
          window.location = code
            ? '/checkout?discount=' + encodeURIComponent(code)
            : '/checkout';
        });
    }

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        checkoutBtn.disabled = false;
        checkoutBtn.querySelector('span').textContent = 'Weiter zur Kasse';
        if (errorEl) {
          errorEl.textContent = data.description || 'Etwas ist schiefgegangen. Bitte versuche es erneut.';
          errorEl.classList.add('is-visible');
        }
        return;
      }
      var code = getCheckoutDiscountCode();
      finalizeCheckout(code);
    })
    .catch(function () {
      checkoutBtn.disabled = false;
      checkoutBtn.querySelector('span').textContent = 'Weiter zur Kasse';
      if (errorEl) {
        errorEl.textContent = 'Etwas ist schiefgegangen. Bitte versuche es erneut.';
        errorEl.classList.add('is-visible');
      }
    });
  });

  // Initial state
  updateState();
})();
